import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Atendente } from '../model/atendente';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAtendenteService {

  constructor(private http: HttpClient,
  public global: GlobalService) { }
  user = this.global.user;
  pass = this.global.pass;
  auth = btoa(this.user + ':' + this.pass);

  dominio = this.global.dominio;
  atendenteUrl = this.dominio + '/backend/api/v2/atendente';
  criptoUrl = '40.75.0.195:8081/criptografiatech/';

  listarTodas(): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.atendenteUrl}/todos`, { headers })
      .toPromise();
  }


  getById(codigo: any): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.atendenteUrl}/mostrar/${codigo}`, { headers })
      .toPromise();
  }


  GetByNome(text: string): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.atendenteUrl}/pesquisarNome/${text}`, { headers })
      .toPromise();
  }


  criptografia(bodyUrl): Promise<Atendente> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    headers = headers.set('Content-Type', 'application/json');
    const body = JSON.stringify(bodyUrl);
    console.log(body);
    return this.http.post<Atendente>(`http://40.75.0.195:8081/criptografiatech/crip`, body, { headers })
      .toPromise();

  }

  setarLink(id: any, link: any): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.atendenteUrl}/setarLink/${id}/${link}`, { headers })
      .toPromise();
  }

  gerarLink(id: any, tempo): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.get(`${this.atendenteUrl}/gerarLink/${id}/${tempo}`, { headers })
      .toPromise();
  }


  excluir(codigo: any): Promise<void> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    return this.http.delete(`${this.atendenteUrl}/deletar/${codigo}`, { headers })
      .toPromise()
      .then(() => null);
  }

  save(atendente: Atendente) {
    if (atendente.id) {
      return this.atualizar(atendente);
    } else {
      return this.adicionar(atendente);
    }
  }

  adicionar(atendente: Atendente): Promise<Atendente> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(atendente);
    return this.http.post<Atendente>(`${this.atendenteUrl}/inserir`, body, { headers })
      .toPromise();

  }


  atualizar(atendente: Atendente): Promise<Atendente> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + this.auth);
    const body = JSON.stringify(atendente);
    return this.http.put(`${this.atendenteUrl}/editar`, body, { headers })
      .toPromise()
      .then(response => {
        const pessoaAlterada = response as Atendente;
        return pessoaAlterada;
      });
  }




}

